import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
} from "@chakra-ui/react";
import {
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdFacebook,
  MdOutlineEmail,
} from "react-icons/md";
import { BsGithub, BsLinkedin, BsPerson } from "react-icons/bs";
import axiox from "axios";
import { useState } from "react";
import swal from "sweetalert";
import { AiOutlineMobile } from "react-icons/ai";

export default function From() {
  const [messages, setmessages] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleonchange = (e) => {
    const { name, value } = e.target;
    setmessages({
      ...messages,
      [name]: value,
    });
  };

  const SendMess = () => {
    if (
      (messages.name !== "",
      messages.email !== "",
      messages.phone !== "",
      messages.message !== "")
    ) {
      axiox
        .post(
          "https://rohaantelangur-8b0c0-default-rtdb.firebaseio.com/message.json",
          messages
        )
        .then((res) => {
          console.log(res);
        })
        .then(() => {
          swal("Message Send!", "You clicked the button!", "success");
          setmessages({
            name: "",
            email: "",
            phone: "",
            message: "",
          })
        })
        .catch((err) => {
          swal("Oops!", "Some thing wrong!", "error");
        });
    } else {
      swal("Oops!", "Please fill all Details!", "warning");
    }
  };

  return (
    <Container bg="#fffff" maxW="full" mt={0} centerContent overflow="hidden">
      <Flex>
        <Box
          bg="rgb(220, 20, 60)"
          color="white"
          borderRadius="lg"
          m={{ sm: 4, md: 16, lg: 10 }}
          p={{ sm: 5, md: 5, lg: 5 }}
        >
          <Box p={4}>
            <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
              <WrapItem>
                <Box>
                  <Heading color="black">Contact</Heading>
                  <Text mt={{ sm: 3, md: 3, lg: 5 }} color="black">
                    Fill up the form below to contact
                  </Text>
                  <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                    <VStack pl={0} spacing={3} alignItems="flex-start">
                      <Button
                        size="md"
                        height="48px"
                        width="200px"
                        variant="ghost"
                        color="black"
                        _hover={{ border: "2px solid black" }}
                        leftIcon={<MdPhone color="black" size="20px" />}
                      >
                        +91-9637350755
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        width="200px"
                        variant="ghost"
                        color="black"
                        _hover={{ border: "2px solid black" }}
                        leftIcon={<MdEmail color="black" size="20px" />}
                      >
                        rtelangur@gmail.com
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        width="200px"
                        variant="ghost"
                        color="black"
                        _hover={{ border: "2px solid black" }}
                        leftIcon={<MdLocationOn color="black" size="20px" />}
                      >
                        Ahmednagar, India
                      </Button>
                    </VStack>
                  </Box>
                  <HStack
                    mt={{ lg: 10, md: 10 }}
                    spacing={5}
                    px={5}
                    alignItems="flex-start"
                  >
                    <a href="" target="_blank">
                      <IconButton
                        aria-label="facebook"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: "black" }}
                        icon={<MdFacebook size="28px" />}
                      />
                    </a>

                    <a href="https://github.com/rohaantelangur" target="_blank">
                      <IconButton
                        aria-label="github"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: "black" }}
                        icon={<BsGithub size="28px" />}
                      />
                    </a>

                    <a href="https://www.linkedin.com/in/rohan-telangur/" target="_blank">
                      <IconButton
                        aria-label="Linkedin"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: "black" }}
                        icon={<BsLinkedin size="28px" />}
                      />
                    </a>
                  </HStack>
                </Box>
              </WrapItem>
              <WrapItem>
                <Box bg="white" borderRadius="lg">
                  <Box m={8} color="#0B0E3F">
                    <VStack spacing={5}>
                      <FormControl id="name">
                        <FormLabel>Your Name</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<BsPerson color="gray.800" />}
                          />
                          <Input
                            type="text"
                            size="md"
                            name="name"
                            onChange={handleonchange}
                            value={messages.name}
                            required
                          />
                        </InputGroup>
                      </FormControl>
                      <FormControl id="name">
                        <FormLabel>Mail</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<MdOutlineEmail color="gray.800" />}
                          />
                          <Input
                            type="text"
                            size="md"
                            name="email"
                            onChange={handleonchange}
                            value={messages.email}
                            required
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl id="name">
                        <FormLabel>Mobile No</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<AiOutlineMobile color="gray.800" />}
                          />
                          <Input
                            type="number"
                            size="md"
                            name="phone"
                            onChange={handleonchange}
                            value={messages.phone}
                            required
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl id="name">
                        <FormLabel>Message</FormLabel>
                        <Textarea
                          borderColor="gray.300"
                          _hover={{
                            borderRadius: "gray.300",
                          }}
                          name="message"
                          onChange={handleonchange}
                          placeholder="message"
                          value={messages.message}
                          required
                        />
                      </FormControl>
                      <FormControl id="name" float="right">
                        <Button
                          variant="solid"
                          bg="rgb(220, 20, 60)"
                          color="white"
                          _hover={{}}
                          onClick={SendMess}
                        >
                          Send Message
                        </Button>
                      </FormControl>
                    </VStack>
                  </Box>
                </Box>
              </WrapItem>
            </Wrap>
          </Box>
        </Box>
      </Flex>
    </Container>
  );
}
